import React from 'react'
import PropTypes from 'prop-types'

import CircularProgress from 'material-ui/CircularProgress'
import Checkbox from 'material-ui/Checkbox'

const CalendarsList = ({ calendarsState, onCalendarToggled }) => {

  const comparer = (c0, c1) => {
    const c0Imported = calendarsState.isImported(c0.id)
    const c1Imported = calendarsState.isImported(c1.id)
    if (c0Imported ^ c1Imported) {
      return c0Imported ? -1 : 1
    }
    return c0.summary.localeCompare(c1.summary, 'co', { sensitivity: 'base' })
  }

  const getSortedCalendars = () => {
    const sorted = calendarsState.getUserCalendars()
    sorted.sort(comparer)
    return sorted
  }

  return (
    <div>
      { getSortedCalendars().map(userCalendar =>
        <Checkbox
          key={userCalendar.id}
          style={styles.calendarItem(calendarsState.isImported(userCalendar.id))}
          label={userCalendar.summary}
          checked={calendarsState.isChecked(userCalendar.id)}
          onCheck={() => onCalendarToggled(userCalendar.id)}
          iconStyle={styles.checkIcon(userCalendar.backgroundColor)} />
      )}
    </div>
  )
}

CalendarsList.propTypes = {
  calendarsState: PropTypes.object,
  onCalendarToggled: PropTypes.func.isRequired
}

const LoadingError = ({ text }) => {
  return (
    <div style={styles.error}>{ text }</div>
  )
}

LoadingError.propTypes = {
  text: PropTypes.string.isRequired
}

export default class UserCalendars extends React.Component {

  static propTypes = {
    calendarsState: PropTypes.object,
    onCalendarToggled: PropTypes.func.isRequired
  }

  render() {
    const calendarsState = this.props.calendarsState
    return (
      <div style={styles.body}>
        <div style={styles.info}>
          <div style={styles.infoTip()}>
            Importing will add all the events from selected calendars to your calendar on Fibo.
          </div>
          <div style={styles.infoTip()}>
            You will then be able to re-assign events to others on your team.
          </div>
        </div>
        <div style={styles.calendarsList}>
          <div style={styles.infoTip(500)}>Calendars</div>
          { calendarsState.isLoading()
            ? <CircularProgress />
            : (calendarsState.hasError()
              ? <LoadingError text={calendarsState.getError()} />
              : <CalendarsList
                calendarsState={calendarsState}
                onCalendarToggled={this.props.onCalendarToggled}/>)
          }
        </div>
      </div>
    )
  }

}

const styles = {

  body: {
    padding: 24
  },

  info: {
    display: 'flex',
    flexDirection: 'column'
  },

  infoTip: weigth => ({
    marginBottom: 12,
    fontWeight: weigth || 400,
    fontFamily: 'Roboto',
    fontSize: 15,
    paddingTop: 6,
    paddingBottom: 6
  }),

  calendarsList: {
    display: 'flex',
    flexDirection: 'column'
  },

  calendarItem: disabled => ({
    marginTop: 6,
    cursor: disabled ? 'not-allowed' : 'pointer'
  }),

  error: {
    color: '#f00',
    fontSize: 15,
    fontWeight: 400
  },

  checkIcon: fill => ({
    fill
  })

}



// WEBPACK FOOTER //
// ./src/schedule/gcal/UserCalendars.js